import { FollowStateEnum } from '../enum/follow-state-enum';

export class FollowsModel {

    // ? for example bookId, commentId ,...
    objectId?: string;
    hasPhoto?: boolean;

    // ? for example book, comment ,... -> 1 for user & 2 for review
    objectTypeId?: any;

    followState?: number;

    ownUser?: boolean;

    fullName?: string;

    myFollowStateWith?: FollowStateEnum;

    selectToCreateRoom?: boolean = false;

    userName?: string;
}
